// 产品类型列表
export const productTypes = [
    'ChatGPT',
    'NetFlix',
    'Spotify',
    'duolinguo',
    'Disney+',
    'Crunchyroll',
    'Canva',
    'MAX',
    'Quizlet',
    'Perplexity',
    'DeepL',
    'Brilliant',
    'Discovery+',
    'QuillBot',
    'Manus',
    "DeepSeek",
    "Gamma",
    "Runway"
]

export const ProductEmailType = {
    netflixLoginCode: "netflix-login-code",
    netflixHouseholdLink: "netflix-household-link",
    netflixTravelLink: "netflix-travel-link",
    disneyLoginCode: "disney-login-code",
    chatgptLoginCode: "chatgpt-login-code",
    perplexityLoginCode: "perplexity-login-code"
}

export const SearchOrderListStatus = {
    // 订单列表搜索状态参数
    ALL: "all",  // 所有订单
    COMPLETED: "completed",  // 生效中订单
    REFUNDED: "refunded",   // 已退款订单
    INPROGRESS: "inprogress",  // 待支付订单
    CLOSED: "closed"   // 已过期订单
}

export const SwapProducts = ['chatgpt', 'netflix', 'crunchyroll', 'perplexity', 'max', 'gamma', 'discovery+', 'disney+']

export const EnableExtendProducts = ['chatgpt', 'netflix', 'crunchyroll', 'perplexity', 'max', 'canva', 'gamma', 'discovery+']

export const ProfileProducts = ['netflix', 'disney+', 'crunchyroll', 'max', 'discovery+']